import React from 'react';

import { MenuItem, TextField } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

interface SelectFilterProps {
  label: string;
  options: Array<{ value: string; label: string }>;
  value?: string;
  onSelect?: (value: string) => void;
  showAllOption?: boolean;
}

const SelectFilter: React.FC<SelectFilterProps> = ({
  label,
  options,
  value,
  onSelect,
  showAllOption = true,
}) => {
  const { t } = useTranslation(['translations']);
  return (
    <TextField
      fullWidth
      select
      label={label}
      variant="outlined"
      value={value ?? ''}
      onChange={(
        e: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
      ) => onSelect && onSelect(e.target.value as string)}
    >
      {showAllOption && (
        <MenuItem value="">{t('stacks_page.table.all')}</MenuItem>
      )}
      {options.map(({ label, value }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectFilter;
